// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domain-merge-modal-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--z-modal, 1000);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(0, 0, 0, 0.72);
  backdrop-filter: blur(8px);
}

.domain-merge-modal {
  width: min(520px, 100%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 18px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.03));
  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.45);
  max-height: 90vh;
  overflow: hidden;
  overflow-y: auto;
}

.domain-merge-modal-header,
.domain-merge-modal-body,
.domain-merge-modal-footer {
  padding: 18px 20px;
}

.domain-merge-modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.domain-merge-modal-kicker {
  margin-bottom: 8px;
  color: rgba(239, 68, 68, 0.82);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.domain-merge-modal-header h3 {
  margin: 0;
  color: var(--text-primary, #f5f5f5);
  font-size: 18px;
  line-height: 1.3;
}

.domain-merge-modal-close {
  border: none;
  background: transparent;
  color: var(--text-muted, rgba(255, 255, 255, 0.62));
  font-size: 28px;
  line-height: 1;
  cursor: pointer;
  padding: 0;
}

.domain-merge-modal-close:hover:not(:disabled) {
  color: var(--text-primary, #fff);
}

.domain-merge-modal-close:disabled {
  opacity: 0.45;
  cursor: default;
}

.domain-merge-modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.domain-merge-modal-label {
  color: var(--text-muted, rgba(255, 255, 255, 0.68));
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.12em;
  text-transform: uppercase;
}

.domain-merge-modal-input {
  width: 100%;
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-primary, #f5f5f5);
  padding: 12px 14px;
  font: inherit;
  outline: none;
}

.domain-merge-modal-input:focus {
  border-color: rgba(239, 68, 68, 0.62);
  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.5);
}

.domain-merge-modal-suggestions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.domain-merge-modal-suggestion {
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: var(--text-secondary, rgba(255, 255, 255, 0.76));
  padding: 7px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}

.domain-merge-modal-suggestion:hover:not(:disabled),
.domain-merge-modal-suggestion.active {
  border-color: rgba(239, 68, 68, 0.35);
  background: rgba(239, 68, 68, 0.12);
  color: #fff;
}

.domain-merge-modal-preview {
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-secondary, rgba(255, 255, 255, 0.76));
  padding: 12px 14px;
  font-size: 13px;
  line-height: 1.45;
}

.domain-merge-modal-error {
  border: 1px solid rgba(239, 68, 68, 0.28);
  border-radius: 12px;
  background: rgba(239, 68, 68, 0.1);
  color: #fca5a5;
  padding: 11px 12px;
  font-size: 12px;
  line-height: 1.4;
}

.domain-merge-modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.domain-merge-modal-btn {
  border-radius: 12px;
  padding: 10px 14px;
  font: inherit;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;
}

.domain-merge-modal-btn:disabled {
  opacity: 0.55;
  cursor: default;
}

.domain-merge-modal-btn-secondary {
  border: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(255, 255, 255, 0.03);
  color: var(--text-secondary, rgba(255, 255, 255, 0.76));
}

.domain-merge-modal-btn-secondary:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.06);
  color: #fff;
}

.domain-merge-modal-btn-primary {
  border: 1px solid rgba(239, 68, 68, 0.72);
  background: rgba(239, 68, 68, 0.9);
  color: #fff;
}

.domain-merge-modal-btn-primary:hover:not(:disabled) {
  background: #dc2626;
  border-color: #dc2626;
}

@media (max-width: 640px) {
  .domain-merge-modal-overlay {
    padding: 16px;
  }

  .domain-merge-modal {
    border-radius: 16px;
  }

  .domain-merge-modal-header,
  .domain-merge-modal-body,
  .domain-merge-modal-footer {
    padding: 16px;
  }

  .domain-merge-modal-footer {
    flex-direction: column-reverse;
  }

  .domain-merge-modal-btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Hierarchy/DomainMergeModal.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,+BAA+B;EAC/B,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,yFAAyF;EACzF,2CAA2C;EAC3C,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;;EAGE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,uBAAuB;EACvB,mDAAmD;EACnD,eAAe;EACf,cAAc;EACd,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,mDAAmD;EACnD,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,mCAAmC;EACnC,kBAAkB;EAClB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,2CAA2C;EAC3C,oBAAoB;EACpB,qCAAqC;EACrC,uDAAuD;EACvD,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;;EAEE,qCAAqC;EACrC,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,qCAAqC;EACrC,uDAAuD;EACvD,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;EACnB,kCAAkC;EAClC,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,qCAAqC;EACrC,uDAAuD;AACzD;;AAEA;EACE,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,yCAAyC;EACzC,kCAAkC;EAClC,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".domain-merge-modal-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: var(--z-modal, 1000);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(0, 0, 0, 0.72);\n  backdrop-filter: blur(8px);\n}\n\n.domain-merge-modal {\n  width: min(520px, 100%);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 18px;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.06), rgba(255, 255, 255, 0.03));\n  box-shadow: 0 32px 80px rgba(0, 0, 0, 0.45);\n  max-height: 90vh;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.domain-merge-modal-header,\n.domain-merge-modal-body,\n.domain-merge-modal-footer {\n  padding: 18px 20px;\n}\n\n.domain-merge-modal-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.domain-merge-modal-kicker {\n  margin-bottom: 8px;\n  color: rgba(239, 68, 68, 0.82);\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.domain-merge-modal-header h3 {\n  margin: 0;\n  color: var(--text-primary, #f5f5f5);\n  font-size: 18px;\n  line-height: 1.3;\n}\n\n.domain-merge-modal-close {\n  border: none;\n  background: transparent;\n  color: var(--text-muted, rgba(255, 255, 255, 0.62));\n  font-size: 28px;\n  line-height: 1;\n  cursor: pointer;\n  padding: 0;\n}\n\n.domain-merge-modal-close:hover:not(:disabled) {\n  color: var(--text-primary, #fff);\n}\n\n.domain-merge-modal-close:disabled {\n  opacity: 0.45;\n  cursor: default;\n}\n\n.domain-merge-modal-body {\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.domain-merge-modal-label {\n  color: var(--text-muted, rgba(255, 255, 255, 0.68));\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: 0.12em;\n  text-transform: uppercase;\n}\n\n.domain-merge-modal-input {\n  width: 100%;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 12px;\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-primary, #f5f5f5);\n  padding: 12px 14px;\n  font: inherit;\n  outline: none;\n}\n\n.domain-merge-modal-input:focus {\n  border-color: rgba(239, 68, 68, 0.62);\n  box-shadow: 0 0 0 1px rgba(239, 68, 68, 0.5);\n}\n\n.domain-merge-modal-suggestions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.domain-merge-modal-suggestion {\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.04);\n  color: var(--text-secondary, rgba(255, 255, 255, 0.76));\n  padding: 7px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.domain-merge-modal-suggestion:hover:not(:disabled),\n.domain-merge-modal-suggestion.active {\n  border-color: rgba(239, 68, 68, 0.35);\n  background: rgba(239, 68, 68, 0.12);\n  color: #fff;\n}\n\n.domain-merge-modal-preview {\n  border: 1px solid rgba(255, 255, 255, 0.06);\n  border-radius: 14px;\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text-secondary, rgba(255, 255, 255, 0.76));\n  padding: 12px 14px;\n  font-size: 13px;\n  line-height: 1.45;\n}\n\n.domain-merge-modal-error {\n  border: 1px solid rgba(239, 68, 68, 0.28);\n  border-radius: 12px;\n  background: rgba(239, 68, 68, 0.1);\n  color: #fca5a5;\n  padding: 11px 12px;\n  font-size: 12px;\n  line-height: 1.4;\n}\n\n.domain-merge-modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.domain-merge-modal-btn {\n  border-radius: 12px;\n  padding: 10px 14px;\n  font: inherit;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: background 150ms ease, border-color 150ms ease, color 150ms ease;\n}\n\n.domain-merge-modal-btn:disabled {\n  opacity: 0.55;\n  cursor: default;\n}\n\n.domain-merge-modal-btn-secondary {\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  background: rgba(255, 255, 255, 0.03);\n  color: var(--text-secondary, rgba(255, 255, 255, 0.76));\n}\n\n.domain-merge-modal-btn-secondary:hover:not(:disabled) {\n  background: rgba(255, 255, 255, 0.06);\n  color: #fff;\n}\n\n.domain-merge-modal-btn-primary {\n  border: 1px solid rgba(239, 68, 68, 0.72);\n  background: rgba(239, 68, 68, 0.9);\n  color: #fff;\n}\n\n.domain-merge-modal-btn-primary:hover:not(:disabled) {\n  background: #dc2626;\n  border-color: #dc2626;\n}\n\n@media (max-width: 640px) {\n  .domain-merge-modal-overlay {\n    padding: 16px;\n  }\n\n  .domain-merge-modal {\n    border-radius: 16px;\n  }\n\n  .domain-merge-modal-header,\n  .domain-merge-modal-body,\n  .domain-merge-modal-footer {\n    padding: 16px;\n  }\n\n  .domain-merge-modal-footer {\n    flex-direction: column-reverse;\n  }\n\n  .domain-merge-modal-btn {\n    width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
